import { render, staticRenderFns } from "./AccessDeniedView.vue?vue&type=template&id=f6b8d80e&scoped=true&"
import script from "./AccessDeniedView.vue?vue&type=script&lang=js&"
export * from "./AccessDeniedView.vue?vue&type=script&lang=js&"
import style0 from "./AccessDeniedView.vue?vue&type=style&index=0&id=f6b8d80e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b8d80e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSlideXTransition})
